import { render, staticRenderFns } from "./OrderTableSettingsDialog.vue?vue&type=template&id=4426fc44"
import script from "./OrderTableSettingsDialog.vue?vue&type=script&lang=js"
export * from "./OrderTableSettingsDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports